export const Claims = {
  AdminUsersView: "admin.users.view",
  AdminUsersEdit: "admin.users.edit",
  AdminUsersAdd: "admin.users.add",
  AdminUsersDelete: "admin.users.delete",
  AdminUsersExport: "admin.users.export",
  AdminTenantsView: "admin.tenants.view",
  AdminTenantsEdit: "admin.tenants.edit",
  AdminTenantsAdd: "admin.tenants.add",
  AdminTenantsDelete: "admin.tenants.delete",
  AdminTenantsExport: "admin.tenants.export",
  AdminETLsView: "admin.etls.view",
  AdminETLsAdd: "admin.etls.add",
  AdminTenantsSyncSkills: "admin.tenants.sync",
};
